import { Waves, Utensils, Home, Music, Wifi, Users, Car, Sun } from 'lucide-react';

export const mockData = {
  navigation: [
    { id: 'about', label: 'About' },
    { id: 'events', label: 'Events' },
    { id: 'gallery', label: 'Gallery' },
    { id: 'amenities', label: 'Amenities' },
    { id: 'testimonials', label: 'Testimonials' },
    { id: 'contact', label: 'Contact' }
  ],

  venue: {
    name: 'Queensland Ranch',
    heroImage: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/zwjiqz9h_IMG_7678.png',
    aboutImage: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/7u00hjcg_IMG_7675.png',
    description: 'Nestled in the scenic landscape of Anthony, New Mexico, Queensland Ranch is a premier event venue where Mediterranean elegance meets southwestern charm. Our stunning property features pristine grounds, a luxurious pool area, and versatile event spaces perfect for creating unforgettable memories.',
    bio: {
      eyebrow: 'Our Story',
      heading: 'A Family Legacy of Celebration',
      paragraphs: [
        'Queensland Ranch is a family-run venue, born from a lifelong love of gathering people together and a deep-rooted belief that every celebration deserves to feel extraordinary. For us, this is far more than a business — it is our passion and our pride.',
        'From the moment you step onto our grounds, you are greeted by the warmth of a family that treats your day as if it were our own. We pour our hearts into every detail, offering genuine, attentive service and an unwavering commitment to excellence. Our promise is simple: every event we host will be as breathtaking, thoughtful, and unforgettable as the last.',
        'We would be truly honored to welcome you, your loved ones, and your guests to Queensland Ranch — and to have the privilege of making your day magical.'
      ],
      signature: 'With all of our love,<br/>The Amato Family'
    },
    address: '5155 NM-28, Anthony, NM'
  },

  contact: {
    name: 'Mary Amato',
    phone: '(915) 261-5444',
    email: 'queenie70582@gmail.com',
    address: '5155 NM-28, Anthony, NM'
  },

  eventTypes: [
    {
      title: 'Weddings',
      image: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/l0squxsc_IMG_9900.jpeg',
      description: 'Create the wedding of your dreams in our elegant Mediterranean setting with breathtaking outdoor spaces.',
      features: [
        'Ceremony & reception spaces',
        'Bridal suite available',
        'Professional event coordination',
        'Customizable décor options'
      ]
    },
    {
      title: 'Corporate Events',
      image: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/zwjiqz9h_IMG_7678.png',
      description: 'Host impressive corporate gatherings, retreats, and team-building events in a sophisticated atmosphere.',
      features: [
        'Conference facilities',
        'Audio-visual equipment',
        'Catering services',
        'Flexible seating arrangements'
      ]
    },
    {
      title: 'Birthday Parties',
      image: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/zltkx8fl_IMG_3139.heic',
      description: 'Celebrate life\'s milestones with unforgettable birthday parties across our beautiful outdoor spaces.',
      features: [
        'Pool access available',
        'Kids & adult-friendly',
        'Customizable party packages',
        'Entertainment options'
      ]
    }
  ],

  gallery: [
    {
      url: 'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/3msrdcoz_IMG_3423.jpeg',
      alt: 'Groom and Father Walking Toward Ceremony'
    },
    {
      url: 'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/9od9jklw_IMG_3298.jpeg',
      alt: 'Bride Portrait at the Villa Entrance'
    },
    {
      url: 'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/rery6n6h_IMG_3303.jpeg',
      alt: 'Ceremony Moment Under the Willow Tree'
    },
    {
      url: 'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/wks7tpsx_IMG_3416.jpeg',
      alt: 'Wedding Group Portrait at the Ceremony Arch'
    },
    {
      url: 'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/kmzjo04u_IMG_3300.jpeg',
      alt: 'Bride and Groom at the Ceremony Arch'
    },
    {
      url: '/weddings/wedding1.jpg',
      alt: 'Elegant Wedding Reception at Queensland Ranch'
    },
    {
      url: '/weddings/wedding2.jpg',
      alt: 'Wedding Celebration'
    },
    {
      url: '/weddings/wedding3.jpg',
      alt: 'Bride and Groom Portrait'
    },
    {
      url: '/weddings/wedding4.jpg',
      alt: 'Wedding Moment'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/rq50w49v_IMG_2475.jpeg',
      alt: 'Magical Evening Reception with Smoke Effect & String Lights'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/lj82794r_IMG_9844.jpeg',
      alt: 'Evening Poolside Reception'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/l0squxsc_IMG_9900.jpeg',
      alt: 'Willow Tree Wedding Ceremony'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/usptf2b8_IMG_8642.jpeg',
      alt: 'Bride and Groom Portrait'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/i1u3pdv6_IMG_8640.jpeg',
      alt: 'Intimate Ceremony Under Willow'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/zn5vhyp3_IMG_4663.jpeg',
      alt: 'Wedding Recessional Down the Aisle'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/iwh2jq8q_IMG_8641.jpeg',
      alt: 'Outdoor Wedding Ceremony Under Willow Tree'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/tdrfmu8s_IMG_8637.jpeg',
      alt: 'Evening Poolside Reception with String Lights'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/zwjiqz9h_IMG_7678.png',
      alt: 'Aerial View of Venue'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/guwddpu7_IMG_5035.heic',
      alt: 'Evening Event with String Lights'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/7u00hjcg_IMG_7675.png',
      alt: 'Outdoor Dining Setup'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/74gl8etz_3024DE58-04E4-4D79-8520-45B1A5CAD3D3.jpeg',
      alt: 'Aerial Property View'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/tbed1qyx_IMG_7674.png',
      alt: 'Table Details'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/2kvyy953_IMG_2446.jpeg',
      alt: 'Venue Event'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/zltkx8fl_IMG_3139.heic',
      alt: 'Birthday Party Celebration'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/y2trenzt_IMG_4601.heic',
      alt: 'Elegant Outdoor Event Setup'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_qranch-events/artifacts/sciixkww_IMG_4594.heic',
      alt: 'Venue Event Space'
    }
  ],

  amenities: [
    {
      icon: Waves,
      title: 'Swimming Pool',
      description: 'Beautiful pool area perfect for summer events and poolside celebrations'
    },
    {
      icon: Utensils,
      title: 'Catering Kitchen',
      description: 'Professional-grade kitchen facilities for exceptional culinary experiences'
    },
    {
      icon: Music,
      title: 'Sound System',
      description: 'Premium audio equipment for entertainment and presentations'
    },
    {
      icon: Wifi,
      title: 'High-Speed WiFi',
      description: 'Reliable internet connectivity throughout the property'
    },
    {
      icon: Users,
      title: 'Flexible Capacity',
      description: 'Accommodate intimate gatherings to large celebrations up to 150 guests'
    },
    {
      icon: Car,
      title: 'Ample Parking',
      description: 'Spacious parking area for all your guests'
    },
    {
      icon: Sun,
      title: 'Beautiful Grounds',
      description: 'Lush landscaping and scenic views for stunning photo opportunities'
    }
  ],

  realWeddings: [
    'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/3msrdcoz_IMG_3423.jpeg',
    'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/9od9jklw_IMG_3298.jpeg',
    'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/rery6n6h_IMG_3303.jpeg',
    'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/wks7tpsx_IMG_3416.jpeg',
    'https://customer-assets-jai6qajn.emergentagent.net/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/kmzjo04u_IMG_3300.jpeg',
    '/weddings/wedding1.jpg',
    '/weddings/wedding2.jpg',
    '/weddings/wedding3.jpg',
    '/weddings/wedding4.jpg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/rz9jv65j_IMG_2483.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/h2hzeqj7_IMG_2480.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/piiasufn_IMG_2484.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/a5vl73zg_IMG_2478.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/qpxl5ux2_IMG_2486.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/h6lm1mbg_IMG_2476.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/dx9q5yyi_IMG_2487.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/maepy0wn_IMG_2477.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/2wu4iipo_IMG_2488.jpeg',
    'https://customer-assets.emergentagent.com/job_e266fb6f-fdc7-42c5-898a-f52b6b6f9863/artifacts/ggbsmdyt_IMG_2479.jpeg'
  ],

  whyChooseUs: [
    {
      icon: 'estate',
      title: 'Private 7-Acre Estate',
      description: 'An expansive, secluded sanctuary reserved exclusively for your celebration — no crowds, no interruptions, only you and your guests.'
    },
    {
      icon: 'family',
      title: 'Family-Owned Experience',
      description: 'Every couple works directly with the Amato family, ensuring personal attention and the kind of care only a family business can deliver.'
    },
    {
      icon: 'packages',
      title: 'Flexible, All-Inclusive Packages',
      description: 'From intimate gatherings to grand celebrations, our thoughtfully tiered packages adapt to your vision — and your budget.'
    },
    {
      icon: 'spaces',
      title: 'Stunning Ceremony & Reception Spaces',
      description: 'Breathtaking outdoor ceremony grounds, a Mediterranean estate backdrop, and elegant reception areas that flow effortlessly.'
    }
  ],

  signatureExperiences: {
    pool: {
      title: 'The Aquatic Oasis',
      tagline: 'A Resort-Style Pool Unlike Any Other',
      description: 'Our signature 50,000-gallon swimming pool is the heart of the estate — a sun-drenched sanctuary designed for celebration and play. A cascading waterfall crowns the deep end, inviting the adventurous to plunge 12 feet into cool, crystalline waters. For the spirited, a sweeping waterslide delivers exhilaration with every descent.',
      features: [
        'Cascading waterfall feature',
        '12 ft deep end with waterslide',
        'Attached jacuzzi that doubles as an enchanting kiddie lagoon',
        'Secluded eight-person jacuzzi just beyond the pool',
        'Certified lifeguard on duty for every poolside celebration',
        'Pool volleyball net and basketball setup available'
      ],
      footer: 'Just behind the pool, a private eight-person jacuzzi offers an intimate retreat beneath the stars — the perfect finale to an unforgettable day.',
      images: [
        '/pool/pool1.jpg',
        '/pool/pool2.jpg',
        '/pool/pool3.jpg',
        '/pool/pool4.jpg'
      ]
    },
    night: {
      title: 'An Evening to Remember',
      tagline: 'Where Twilight Becomes Magic',
      description: 'As the sun sets over Anthony, Queensland Ranch transforms into something cinematic. Canopies of suspended string lights shimmer overhead, casting a warm, romantic glow across our Mediterranean grounds. The grand entrance is framed by a radiant LED-lit archway that welcomes every guest like royalty, while soft illumination traces the pathways, patios, and poolside — bathing the entire property in a timeless, dreamlike ambience.',
      highlights: [
        'Suspended string-light canopies throughout',
        'LED-illuminated grand entrance',
        'Accent lighting across the entire estate',
        'A property that feels built for nightfall'
      ],
      images: [
        '/night/night1.jpg',
        '/night/night2.jpg',
        '/night/night3.jpg',
        '/night/night4.jpg'
      ]
    }
  },

  testimonials: [
    {
      name: 'Sarah & Michael Rodriguez',
      event: 'Wedding Reception',
      text: 'Queensland Ranch made our wedding day absolutely perfect! The venue is stunning, and the staff went above and beyond to make sure everything was flawless. Our guests are still talking about it!'
    },
    {
      name: 'Desert Valley Tech',
      event: 'Corporate Retreat',
      text: 'We hosted our annual company retreat at Queensland Ranch and could not be happier. The facilities were top-notch, and the setting provided the perfect backdrop for team building and networking.'
    },
    {
      name: 'Maria Gonzalez',
      event: '50th Birthday Celebration',
      text: 'The team at Queensland Ranch helped me throw the party of a lifetime! Every detail was perfect, from the elegant setup to the beautiful pool area. Thank you for making my milestone birthday so special!'
    }
  ]
};
